import { Alert } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'

export const UnableToFindClaimAlert = () => {
  const { t } = useTranslation('eMSNPage')
  return (
    <Alert variation='error' hideIcon>
      {t('emsn-results.unable-to-find-claim')}
    </Alert>
  )
}
